


















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { passwordMatchRules, passwordRules } from '@/utils/validation-rules';
import { RequestChangePassword } from '@/api/wps/BackplaneModels';
import { profileModule } from '@/store/modules/moduleProfile';
import backplaneClient from '@/api/backplane/BackplaneClient';
import { constants } from '@/utils/constants';

@Component
export default class UserProfile extends Vue {
  private passwordRules = passwordRules;
  private verifyPasswordRules = passwordMatchRules;
  private displayChangePasswordForm = false;
  private passwordForm = false;
  private passwordModel = '';
  private passwordConfirmModel = '';
  private showPassword = false;
  private resetPasswordError = false;
  private changePasswordLoading = false;
  private showChangePasswordSnackBar = false;
  private currentLanguage = 'en';
  // tooltip
  private tooltip = constants.tooltips.PASSWORD_RULE;

  toggleChangePasswordForm() {
    this.displayChangePasswordForm = !this.displayChangePasswordForm;
  }

  resetPassword() {
    const { passwordFormRef } = this.$refs as any;
    if (passwordFormRef) {
      const valid = passwordFormRef.validate();
      if (valid) {
        this.changePassword();
      }
    }
  }

  changePassword() {
    this.changePasswordLoading = true;
    const changePassword: RequestChangePassword = {
      newPassword: this.passwordModel,
    };
    backplaneClient
      .changePassword(changePassword)
      .toPromise()
      .then(() => {
        this.toggleChangePasswordForm();
        this.showChangePasswordSnackBar = true;
      })
      .catch(() => {
        this.resetPasswordError = true;
      })
      .finally(() => {
        this.changePasswordLoading = false;
      });
  }

  get user() {
    return profileModule.Profile;
  }

  get languages() {
    return [
      { name: 'English', code: 'en' },
      { name: 'Español', code: 'es' },
      { name: 'Français', code: 'fr' },
    ];
  }
}
